const api =
  process.env.NODE_ENV === "production"
    ? "https://menu.huestimates.app/api/controller"
    : "http://localhost:7720/controller";
    const uploadUrl = "https://menu.hu-st.com/upload.php";
    const fileUrl = "https://menu.hu-st.com/";
    const nophoto = "https://menu.hu-st.com/noimage.png";
    const discount = "https://menu.hu-st.com/discount.png";
const AZ_Flag = "https://menu.hu-st.com/AZ.png";
const RU_Flag = "https://menu.hu-st.com/RU.png";
const EN_Flag = "https://menu.hu-st.com/EN.png";

function ShowLink(value) {
  var text = value;
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  var text1 = text.replace(exp, "<a href='$1'>$1</a>");
  var exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

function HtmlNewLine(value) {
  return value.replace(/(?:\r\n|\r|\n)/g, "<br />");
}

function Round2(num) {
  return +(Math.round(num + "e+2")  + "e-2"); // Math.round(num * 100) / 100;
}

function DeliveryTime(from, to) {
  let t = [
    "0:00",
    "1:00",
    "2:00",
    "3:00",
    "4:00",
    "5:00",
    "6:00",
    "7:00",
    "7:30",
    "8:00",
    "8:30",
    "9:00",
    "9:30",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "22:30",
    "23:00",
    "23:30",
  ];
  
  return t.filter(c => Number(c.replace(':', '')) >= Number(from.replace(':','')) 
  & Number(c.replace(':', '')) <= Number(to.replace(':','')))
}

export {
  ShowLink,
  HtmlNewLine,
  uploadUrl,
  fileUrl,
  nophoto,
  discount,
  api,
  Round2,
  AZ_Flag,
  RU_Flag,
  EN_Flag,
  DeliveryTime
};
